/**
 * @class Analytics
 * A simple wrapper for sending ga events
 * Add data-ga="category|action|label" to any element
 * to track it as an event when clicked
 */
export default class FirebaseAnalytics {
  constructor() {
    this.$elements = document.querySelectorAll('[data-firebase]');
    this.$elements.forEach(element => this.constructor.setupElement(element));
  }

  /**
   * @function setupElement
   * @param {HTMLElement} el
   */
  static setupElement(el) {
    el.addEventListener('click', () => {
      if (Object.prototype.hasOwnProperty.call(window, 'firebase')) {
        const date = new Date();
        const parts = el.dataset.firebase.split('|');

        const type = parts[0];
        const screen = parts[1];
        const component = parts[2];

        const eventParams = {
          event_context: 'BACKEND_UAT',
          event_created: date.toLocaleString('en-GB'),
          event_source_system: 'SEATFROG_FRONTEND',
          event_source_service: 'SEATFROG_WEBSITE',
          event_type: type,
          action: 'TAP',
          screen,
          component,
        };
        // eslint-disable-next-line no-undef
        firebase.analytics().logEvent(type, eventParams);
      }
    });
  }
}
